var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.isEN)?_c('Navbar'):_vm._e(),(_vm.$route.meta.isCA)?_c('NavbarCanadian'):_vm._e(),(_vm.$route.meta.isFR)?_c('NavbarFrench'):_vm._e(),_c('router-view'),(_vm.$route.meta.isEN)?_c('Footer'):_vm._e(),(_vm.$route.meta.isCA)?_c('FooterCanadian'):_vm._e(),(_vm.$route.meta.isFR)?_c('FooterFrench'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }